module.exports = __webpack_public_path__ + "media/b4.17bffd26.mp3";